import { render, staticRenderFns } from "./pushDeliverStatsDetail.vue?vue&type=template&id=1e470c04&scoped=true&"
import script from "./pushDeliverStatsDetail.vue?vue&type=script&lang=js&"
export * from "./pushDeliverStatsDetail.vue?vue&type=script&lang=js&"
import style0 from "./pushDeliverStatsDetail.vue?vue&type=style&index=0&id=1e470c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e470c04",
  null
  
)

export default component.exports